import { connect } from 'react-antd-formutil';
import { BankAccountMainTypeEnum, BankAccountMainTypeMap, BankCardItemTypes } from 'components/BankCardSelect';
import FieldSelect from 'components/FieldSelect';
import FormItem from 'components/FormItem';

const config: Array<{
    label: string;
    value: BankCardItemTypes['bankAccountMainType'];
}> = [
    {
        label: BankAccountMainTypeMap[BankAccountMainTypeEnum.Checking],
        value: 1
    },
    {
        label: BankAccountMainTypeMap[BankAccountMainTypeEnum.Savings],
        value: 2
    }
];

const BankAccountMainType: React.FC<{
    defaultValue?: number;
}> = ({ defaultValue }) => {
    return (
        <FormItem
            $defaultValue={defaultValue}
            label={__('Account Type')}
            name="bankAccountMainType"
            checker={value => !!value || __('请选择银行卡类型')}>
            <FieldSelect data={config} />
        </FormItem>
    );
};

export default connect(BankAccountMainType);
